module.exports = __webpack_public_path__ + "img/eyezen-white.10a0d036.svg";